module.exports = __webpack_public_path__ + "static/media/01A.cd536bc3.png";